(function(){
  function init(){
    document.querySelectorAll('[data-zabdi-must-gallery]').forEach(function(gallery){
      if(gallery.dataset.ready==='1')return;
      gallery.dataset.ready='1';
      var buttons=gallery.querySelectorAll('[data-zabdi-must-view]');
      var group=gallery.querySelector('[data-zabdi-must-group]');
      var lifestyle=gallery.querySelector('[data-zabdi-must-lifestyle]');
      buttons.forEach(function(button){
        button.addEventListener('click',function(){
          var showLifestyle=button.dataset.zabdiMustView==='lifestyle';
          group.hidden=showLifestyle;
          lifestyle.hidden=!showLifestyle;
          buttons.forEach(function(item){var selected=item===button;item.classList.toggle('is-selected',selected);item.setAttribute('aria-pressed',String(selected));});
        });
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();